module.exports = __webpack_public_path__ + "img/yun-icon.4e67c94f.png";